import api from "../services/api"

const getAllOptionsByMetaAds = async () => {
    try {
        const response = await api.get("/leads/meta-ads")
        const data = response.data?.data || {}
        return data
    } catch (err) {
        console.log(err?.response?.data?.message)
        return {}
    }
}

const getAllAdAccounts = async () => {
    try {
        const response = await api.get("/integrations/meta/adAccounts")
        const adAccounts = response.data?.data || []
        return adAccounts
    } catch (err) {
        console.log(err?.response?.data?.message)
        return []
    }
}

export { getAllOptionsByMetaAds, getAllAdAccounts }